import type { RequireAtLeastOne } from "type-fest";

import { Button, Flex, Group, Image, Stack, Text } from "@mantine/core";
import { useEffect } from "react";

import { useLogger } from "@/sdk/logging/LoggerProvider";

import LostAstronaut from "../assets/image/LostAstronaut.svg";
import classes from "./GlobalError.module.css";

type GlobalErrorProps = RequireAtLeastOne<{ title?: string; msg?: string }> & {
    /** Shows a Refresh button that calls this. */
    onRefresh?: () => void;
};

export function GlobalError({ msg, title, onRefresh }: GlobalErrorProps) {
    const logger = useLogger({ module: "global" });
    useEffect(() => {
        if (msg) logger.fatal({ title }, msg);
        else logger.fatal(title);
    }, [logger, msg, title]);

    return (
        <Flex justify="center" align="center" h="100vh" p="xl" w="100vw" className={classes.mainFlexContainer}>
            <Stack maw={500}>
                <Text fw="var(--mantine-font-weight-heavy)" c="dark.0">
                    {title ?? "Something’s not right-try refreshing the page"}
                </Text>
                <Text fw="var(--mantine-font-weight-light)" c="dark.1" w="95%">
                    {msg ?? "Try again in a bit, or see if refreshing helps."}
                </Text>
                {onRefresh && (
                    <Group>
                        <Button mt="sm" onClick={onRefresh} variant="outline" c="white" color="asurion.5">
                            Refresh
                        </Button>
                    </Group>
                )}
            </Stack>
            <Group className={classes.asset}>
                <Image src={LostAstronaut} alt="Lost astronaut" />
            </Group>
        </Flex>
    );
}
